import * as React from 'react';
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
  Box,
  Chip,
  Typography
} from '@mui/material';
import { Clear, FilterList } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Styled components for better layout
const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  padding: theme.spacing(1),
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 200,
  [theme.breakpoints.down('sm')]: {
    minWidth: 150,
  }
}));

const FilterChip = styled(Chip)(({ theme }) => ({
  height: 40,
  fontSize: '0.875rem',
  fontWeight: 500,
  '& .MuiChip-deleteIcon': {
    fontSize: '1.2rem',
  }
}));

export default function CategoryFilter({catgories, category, setCategory}) {

  const handleChange = (event) => {
    setCategory(event.target.value);
  };

  const handleClearFilter = () => {
    setCategory('');
  };

  const formatCategoryLabel = (cat) => {
    return cat.charAt(0).toUpperCase() + cat.slice(1).replace(/_/g, ' ');
  };

  return (
    <FilterContainer>
      <Box display="flex" alignItems="center" gap={1}>
        <FilterList color="action" fontSize="small" />
        <Typography variant="body2" color="text.secondary" fontWeight="medium">
          Filter by:
        </Typography>
      </Box>
      
      <StyledFormControl variant="outlined" size="small">
        <InputLabel id="category-filter-label">Category</InputLabel>
        <Select
          labelId="category-filter-label"
          id="category-filter-select"
          value={category || ''}
          label="Category"
          onChange={handleChange}
          displayEmpty
        >
          <MenuItem value="" disabled>
            <Typography color="text.secondary">Select a category</Typography>
          </MenuItem>
          <MenuItem value="">
            <Typography>All Categories</Typography>
          </MenuItem>
          {catgories?.map((cat, i) => (
            <MenuItem key={i} value={cat}>
              {formatCategoryLabel(cat)}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>

      {category && (
        <FilterChip
          label={formatCategoryLabel(category)}
          onDelete={handleClearFilter}
          deleteIcon={<Clear />}
          sx={{
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              backgroundColor: 'primary.dark',
            }
          }}
        />
      )}
    </FilterContainer>
  );
}